import IconButton from "@material-ui/core/IconButton";
import { lighten } from "@material-ui/core/styles/colorManipulator";
import BrushIcon from "@material-ui/icons/Brush";
import { TToolbarComponentProps } from "mui-rte/src/components/Toolbar";
import React from "react";

export const SetColorToolbarButtonComponent = (props: TToolbarComponentProps) => {
  const { id, active, disabled, onMouseDown } = props;

  const colorResult = /color-(.*)-button/.exec(id);

  if (!colorResult) {
    throw Error("SetColorToolbarButton id is not in the correct format.");
  }

  const color = active ? colorResult[1] : lighten(colorResult[1], 0.5);

  return (
    <IconButton id={id} disabled={disabled} onMouseDown={onMouseDown}>
      <BrushIcon style={{ color }} />
    </IconButton>
  );
};

export const SetColorToolbarButton = SetColorToolbarButtonComponent;
